import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Authorization from './pages/Authorization/Authorization'
import IssuesPage from './pages/Issue/IssuesPage'
import HomePage from './pages/HomePage/HomePage'
import OrdersPage from './pages/OrdersPage/OrdersPage'
import Devices from './pages/Devices/Devices'

const ReportsPage  = React.lazy(() => import('./pages/Reports/ReportsPage'))
const AdminPanel = React.lazy(() => import('./pages/AdminPanel/AdminPanel'))

type Props = {
  isAuthentificated?: boolean
  isAdmin: boolean
}

const router = (props: Props) => {
  const { isAuthentificated, isAdmin } = props
  return (
    <Routes>
      <Route path="*" element={<HomePage />} />
      <Route path="/" element={<HomePage />} />
      <Route path="/Home" element={<HomePage />} />
      <Route path="/Home/:id" element={<HomePage />} />

      <Route path="devices" element={<Devices />} />
      <Route path="devices/:id" element={<Devices />} />

      <Route path="issue" element={<IssuesPage />} />

      <Route path="orders" element={<OrdersPage />} />
      <Route path="orders/:id" element={<OrdersPage />} />

      <Route path="reports" element={<ReportsPage />} />

      {isAdmin ? adminRoute() : null}
      {isAuthentificated ? authRoute() : noAuthRoute()}
    </Routes>
  )
}

const adminRoute = () => {
  return (
    <>
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/admin/:value" element={<AdminPanel />} />
    </>
  )
}

const noAuthRoute = () => {
  // Добавить isRegistration в элемент, если нужна регистрация 
  return (
    <>
      <Route path="login" element={<Authorization />} />
      <Route path="registration" element={<Authorization />} />
    </>
  )
}

const authRoute = () => {
  return (
    <>
      <Route path="login" element={<Navigate replace to="/home" />} />
    </>
  )
}

export default router
